@if (packagingsControl && packagingsControl.length) {
  <form id="mainForm" [formGroup]="gformGroup">
    <div class="pagecontent">
      @if (lnk_packagings) {
        <table class="mat-elevation-z1" style="width: 100%;" >
          <tr>
            <th class="mdc-data-table__header-cell">Conditionnement</th>
            <th class="mdc-data-table__header-cell">Multiple de l'UVC</th>
            <th class="mdc-data-table__header-cell">Code Barre</th>
            <th class="mdc-data-table__header-cell">Principal</th>
            <th class="mdc-data-table__header-cell">&nbsp;</th>
          </tr>
          <ng-container formArrayName="lnk_packagings">
            @for (varform of lnk_packagings.controls; track varform; let i = $index) {
              <tr class="form-row">
                <td>
                  {{ $any(varform).get("lnk_packaging")?.get('name')?.value }}
                </td>
                <td>
                  {{ $any(varform).get("lnk_packaging")?.get('qty')?.value }}
                </td>
                <td>
                  <input type = "text" [formControl]="$any(varform).get('barcode')"  >
                </td>
                <td>
                  <mat-checkbox [formControl]="$any(varform).get('is_default')" color="primary"></mat-checkbox>
                </td>
                <td>
                  <button mat-button color="primary" aria-label="Supprimer un code barre" (click)="delete_packagingval(varform)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            }
          </ng-container>
          <!-- Add a BC -->
          <tr>
            <td colspan="4"><mat-divider></mat-divider></td>
          </tr>
          <tr>
            <td>
              @if (true) {
                <mat-form-field>
                  <mat-select [formControl]="newpackaging">
                    @for (p of templatepackagings; track p) {
                      <mat-option value="{{ p.packaging }}">
                        {{ p.lnk_packaging.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </td>
            <td>&nbsp;</td>
            <td>
              <input type = "text" [formControl]="newbarcode" >
            </td>
            <td>
              <button mat-button color="primary" aria-label="Ajouter un code barre" (click)="post_packagingval()">
                <mat-icon>add</mat-icon>
              </button>
            </td>
          </tr>
        </table>
      }
    </div>
  </form>
}